/**
 * Schedules a callback to run during the browser's idle period using `requestIdleCallback` (with a 1000ms timeout).
 * Falls back to calling the callback immediately if `requestIdleCallback` is not supported by the browser.
 */
const requestOnIdleCallback = (toExecute: any) => {
    if (window.requestIdleCallback) {
        window.requestIdleCallback(() => toExecute(), { timeout: 1000 });
    } else {
        toExecute();
    }
};

export { requestOnIdleCallback };
